/* ==========================================================================
   Dutch Barn Vodka | Mobile nav CRO test | Variant E
   Tracking only. The drawer itself is opened and closed by the theme.
   Pushes to window.dataLayer (all events carry nav_variant):
     nav_test_open    drawer opened
     nav_test_close   drawer closed
     nav_test_click   any tracked element in the nav, with nav_group, nav_item,
                      nav_position and nav_url
   Add ?navdebug to the URL to also log each event to the console.
   ========================================================================== */
(function () {
  'use strict';

  var drawer = document.getElementById('mobile-menu');
  var nav = drawer && drawer.querySelector('[data-nav-variant]');
  if (!drawer || !nav) return;

  var VARIANT = nav.getAttribute('data-nav-variant') || 'E';
  var DEBUG = /[?&]navdebug\b/.test(window.location.search);

  function track(name, extra) {
    var payload = { event: name, nav_variant: VARIANT };
    for (var key in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, key)) payload[key] = extra[key];
    }
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (DEBUG && window.console) console.log('[nav test]', payload);
  }

  /* Open and close, read from the theme's own .active class on the drawer */
  var wasOpen = drawer.classList.contains('active');
  new MutationObserver(function () {
    var isOpen = drawer.classList.contains('active');
    if (isOpen === wasOpen) return;
    wasOpen = isOpen;
    track(isOpen ? 'nav_test_open' : 'nav_test_close', {});
  }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

  /* Clicks on anything with data-nav-item */
  var trackable = nav.querySelectorAll('[data-nav-item]');

  nav.addEventListener('click', function (event) {
    var el = event.target.closest('[data-nav-item]');
    if (!el || !nav.contains(el)) return;

    track('nav_test_click', {
      nav_group: el.getAttribute('data-nav-group'),
      nav_item: el.getAttribute('data-nav-item'),
      nav_position: Array.prototype.indexOf.call(trackable, el) + 1,
      nav_url: el.getAttribute('href')
    });
  });
})();